import { render, staticRenderFns } from "./CafkaLogs.vue?vue&type=template&id=2780a1a4&"
import script from "./CafkaLogs.vue?vue&type=script&lang=ts&"
export * from "./CafkaLogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports